import React from 'react'


const LogoHeader = ({ src, className, linkUrl, width, height}) => {
    return (
        <div className={className}>
            <a href={linkUrl}>
                <img width={width} height={height} src={src} alt='bocesLogo'/>
            </a>
        </div>
    )
}

export default LogoHeader
